import { render, staticRenderFns } from "./ProductCardsSelector.vue?vue&type=template&id=4b9a3279&"
import script from "./ProductCardsSelector.vue?vue&type=script&lang=ts&"
export * from "./ProductCardsSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports